import axios from '@/axios/globalaxios'

export const findWarningByAcid = data =>{
    return axios({
        url: "/tradelab/marketPortfolioManagement/findWarningByAcid",
        method: 'post',
        data:data
    })
}